import ApartmentIcon from "@mui/icons-material/Apartment";
import PersonIcon from "@mui/icons-material/Person";
import {
  Box,
  Button,
  Container,
  Dialog,
  Grid,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CountriesSelect from "components/CountriesSelect";
import PhoneField from "components/PhoneField";
import SectionTitle from "components/SectionTitle";
import { SettingsContext } from "context/Settings.context";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import SERVICES from "services";

const useStyles = makeStyles((theme) => ({
  container: {
    scrollMargin: "100px",
  },
  phoneInput: {
    height: "50px",
    // marginBottom: 25,
    // border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "12px",
    padding: "0px 15px",
    "& .PhoneInputInput": {
      border: "none",
      height: 40,
      fontSize: 16,
      outline: "none",
    },
    "& .PhoneInput--focus": {
      border: "1px solid #13A800",
    },
    "& .PhoneInputCountrySelectArrow": {
      border: "none",
    },
  },
  inputTitle: {
    fontWeight: 1000,
    lineHeight: 2,
    color: "#252733",
    fontSize: 16,
    letterSpacing: "0.4px",
  },
  asterisk: {
    fontWeight: 700,
    letterSpacing: "0.4px",
    color: "#EF4444",
    marginLeft: 5,
  },
  btnSection: {
    display: "flex",
    justifyContent: "center",
  },
  textField: {
    height: 40,
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
    },
  },
  countriesSelect: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
    },
  },
  bulkInBuy: {
    "&.MuiButtonBase-root": {
      height: 55,
      zIndex: 5,
      textTransform: "unset",
      backgroundColor: "#13A800",
      color: "white",
      borderRadius: 12,
      fontWeight: 700,
      fontSize: 16,
      padding: "5px 30px",
      "&:hover": {
        background: theme.palette.primary.main,
      },
      "&.Mui-disabled": {
        pointerEvents: "auto",
        cursor: "not-allowed",
        opacity: 0.7,
      },
    },
  },
  submitBtn: {
    "&.MuiButtonBase-root": {
      textTransform: "unset",
      background: theme.palette.primary.main,
      color: "white",
      marginTop: 10,
      borderRadius: 12,
      fontWeight: 700,
      fontSize: 22,
      padding: "5px 30px",
      width: "30%",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      "&:hover": {
        background: theme.palette.primary.main,
      },
    },
  },
}));

const initialState = {
  name: "",
  email: "",
  telephone: "",
  country_id: "",
  weight: "",
  length: "",
  width: "",
  height: "",
  description: "",
  // COMPANY FORM
  company_name: "",

  account_type: "" /* company or personal */,
};

function BuyInBulk() {
  const { t } = useTranslation();

  const classes = useStyles();
  const [dialog, setDialog] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  const [form, setForm] = useState(initialState);
  const [inputErrors, setInputErrors] = useState({});

  const isMobile = useMediaQuery("(max-width:600px)");

  const { dispatch: dispatchToast } = useContext(SettingsContext);
  const handleChange = (event) => {
    setForm((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };
  const handleSubmit = async () => {
    if (inputErrors?.telephone) return;
    const updatedForm = {
      ...form,
      account_type: tabIndex === 0 ? "personal" : "company",
    };
    tabIndex === 0 && delete updatedForm.company_name;

    setForm(updatedForm);
    setInputErrors({});

    try {
      await SERVICES.ACTIONS.sendBulkBuyForm(updatedForm);
      setDialog(false);
      setForm(initialState);
      dispatchToast({
        type: "SUCCESS_TOAST",
        payload: { message: "Success action" },
      });
    } catch (err) {
      if (typeof err.message === "string") {
        dispatchToast({
          type: "ERROR_TOAST",
          payload: { message: err.message },
        });
      }
    }
  };

  return (
    <Container maxWidth={"xl"} id="buyInBulk" className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SectionTitle title={t("bulkInquiry.mainTitle")} />
          <Button
            variant="contained"
            size="large"
            className={classes.bulkInBuy}
            onClick={() => setDialog(true)}
          >
            {t("bulkInquiry.mainButtonTitle")}
          </Button>
          <Dialog
            fullWidth
            maxWidth="lg"
            open={dialog}
            onClose={() => {
              setInputErrors([]);
              setForm(initialState);
              setDialog(false);
            }}
            className={classes.dialog}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Tabs
                  TabIndicatorProps={{ hidden: true }}
                  orientation={isMobile ? "vertical" : "horizontal"}
                  sx={{
                    "& .MuiTab-root": {
                      color: "#666",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      "&.Mui-selected": {
                        color: "#13a800",
                      },
                    },
                  }}
                  centered
                  value={tabIndex}
                  onChange={(event, newValue) => {
                    setForm([]);
                    setInputErrors([]);
                    setTabIndex(newValue);
                  }}
                >
                  <Tab
                    defaultChecked
                    label={t("bulkInquiry.modal.personalAccount")}
                    tabIndex={0}
                    icon={<PersonIcon />}
                  />
                  <Tab
                    label={t("bulkInquiry.modal.companyAccount")}
                    tabIndex={1}
                    icon={<ApartmentIcon />}
                  />
                </Tabs>
              </Box>
              {tabIndex === 0 && (
                <Box p={2}>
                  <Typography
                    variant="h6"
                    align="center"
                    style={{ marginBottom: 20 }}
                  >
                    {t("bulkInquiry.mainButtonTitle")}
                  </Typography>
                  <ValidatorForm
                    onSubmit={handleSubmit}
                    onError={() => {
                      if (!form.phone) {
                        setInputErrors((prev) => ({
                          ...prev,
                          telephone: t("global.required"),
                        }));
                      }
                    }}
                  >
                    <Grid container gap={3} pb={3}>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("addOrderDialog.name")}
                          <span className={classes.asterisk}>*</span>
                        </span>
                        <TextValidator
                          size="small"
                          fullWidth
                          className={classes.textField}
                          name="name"
                          value={form.name || ""}
                          onChange={handleChange}
                          validators={["required", "minStringLength:2"]}
                          errorMessages={[
                            t("global.required"),
                            "Min 2 characters",
                          ]}
                          error={!!inputErrors.name}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("bulkInquiry.modal.email")}
                          <span className={classes.asterisk}>*</span>
                        </span>
                        <TextValidator
                          size="small"
                          className={classes.textField}
                          fullWidth
                          name="email"
                          value={form.email || ""}
                          onChange={handleChange}
                          validators={["required", "isEmail"]}
                          errorMessages={[
                            t("global.required"),
                            "Email is invalid.",
                          ]}
                          error={!!inputErrors.email}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("bulkInquiry.modal.phoneNumber")}
                          <span className={classes.asterisk}>*</span>
                        </span>
                        <PhoneField
                          {...{
                            telephoneErr: inputErrors.telephone,
                            setInputErrors,
                            name: "telephone",
                            value: form.telephone,
                            setForm,
                            hideLabel: true,
                            isRequired: true,
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <CountriesSelect
                          {...{
                            customClassName: classes.countriesSelect,
                            value: form.country_id,
                            onFormChange: setForm,
                            helperText: inputErrors.country_id,
                            error: !!inputErrors.country_id,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("bulkInquiry.modal.weight")}
                        </span>
                        <TextValidator
                          size="small"
                          className={classes.textField}
                          fullWidth
                          name="weight"
                          type="number"
                          value={form.weight || ""}
                          onChange={handleChange}
                          error={!!inputErrors.weight}
                        />
                      </Grid>
                      <Grid
                        container
                        direction={"row"}
                        gap={1}
                        justifyContent={"space-between"}
                      >
                        <Grid item xs={12} md={3.8}>
                          <span className={classes.inputTitle}>
                            {" "}
                            {t("bulkInquiry.modal.length")}
                          </span>
                          <TextValidator
                            size="small"
                            className={classes.textField}
                            fullWidth
                            name="length"
                            type="number"
                            value={form.length || ""}
                            onChange={handleChange}
                            error={!!inputErrors.length}
                          />
                        </Grid>
                        <Grid item xs={12} md={3.8}>
                          <span className={classes.inputTitle}>
                            {" "}
                            {t("bulkInquiry.modal.width")}
                          </span>
                          <TextValidator
                            size="small"
                            className={classes.textField}
                            fullWidth
                            name="width"
                            type="number"
                            value={form.width || ""}
                            onChange={handleChange}
                            error={!!inputErrors.width}
                          />
                        </Grid>
                        <Grid item xs={12} md={3.8}>
                          <span className={classes.inputTitle}>
                            {t("bulkInquiry.modal.height")}
                          </span>
                          <TextValidator
                            size="small"
                            className={classes.textField}
                            fullWidth
                            name="height"
                            type="number"
                            value={form.height || ""}
                            onChange={handleChange}
                            error={!!inputErrors.height}
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {" "}
                          {t("bulkInquiry.modal.description")}
                        </span>
                        <TextValidator
                          size="small"
                          className={classes.textField}
                          fullWidth
                          name="description"
                          value={form.description || ""}
                          onChange={handleChange}
                          error={!!inputErrors.description}
                        />
                      </Grid>
                    </Grid>
                    <div className={classes.btnSection}>
                      <Button
                        variant="contained"
                        className={classes.submitBtn}
                        type="submit"
                      >
                        {t("bulkInquiry.modal.send")}
                      </Button>
                    </div>
                  </ValidatorForm>
                </Box>
              )}
              {tabIndex === 1 && (
                <Box p={2}>
                  <Typography
                    variant="h6"
                    align="center"
                    style={{ marginBottom: 20 }}
                  >
                    {t("bulkInquiry.mainButtonTitle")}
                  </Typography>
                  <ValidatorForm
                    onSubmit={handleSubmit}
                    onError={() => {
                      if (!form.phone_number) {
                        setInputErrors((prev) => ({
                          ...prev,
                          telephone: t("global.required"),
                        }));
                      }
                    }}
                  >
                    <Grid container gap={3} pb={3}>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("bulkInquiry.modal.companyName")}
                          <span className={classes.asterisk}>*</span>
                        </span>
                        <TextValidator
                          size="small"
                          fullWidth
                          className={classes.textField}
                          name="company_name"
                          value={form.company_name || ""}
                          onChange={handleChange}
                          validators={["required", "minStringLength:2"]}
                          errorMessages={[
                            t("global.required"),
                            "Min 2 characters",
                          ]}
                          error={!!inputErrors.company_name}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("bulkInquiry.modal.companyRepresentativeName")}
                          <span className={classes.asterisk}>*</span>
                        </span>
                        <TextValidator
                          size="small"
                          fullWidth
                          className={classes.textField}
                          name="name"
                          value={form.name || ""}
                          onChange={handleChange}
                          validators={["required", "minStringLength:2"]}
                          errorMessages={[
                            t("global.required"),
                            "Min 2 characters",
                          ]}
                          error={!!inputErrors.name}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("bulkInquiry.modal.email")}
                          <span className={classes.asterisk}>*</span>
                        </span>
                        <TextValidator
                          size="small"
                          className={classes.textField}
                          fullWidth
                          name="email"
                          value={form.email || ""}
                          onChange={handleChange}
                          validators={["required", "isEmail"]}
                          errorMessages={[
                            t("global.required"),
                            "Email is invalid.",
                          ]}
                          error={!!inputErrors.email}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("bulkInquiry.modal.phoneNumber")}
                          <span className={classes.asterisk}>*</span>
                        </span>
                        <PhoneField
                          {...{
                            telephoneErr: inputErrors.telephone,
                            setInputErrors,
                            name: "telephone",
                            value: form.telephone,
                            setForm,
                            hideLabel: true,
                            isRequired: true,
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <CountriesSelect
                          {...{
                            customClassName: classes.countriesSelect,
                            value: form.country_id,
                            onFormChange: setForm,
                            helperText: inputErrors.country_id,
                            error: !!inputErrors.country_id,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {t("bulkInquiry.modal.weight")}
                        </span>
                        <TextValidator
                          size="small"
                          className={classes.textField}
                          fullWidth
                          name="weight"
                          type="number"
                          value={form.weight || ""}
                          onChange={handleChange}
                          error={!!inputErrors.weight}
                        />
                      </Grid>
                      <Grid
                        container
                        direction={"row"}
                        gap={1}
                        justifyContent={"space-between"}
                      >
                        <Grid item xs={12} md={3.8}>
                          <span className={classes.inputTitle}>
                            {" "}
                            {t("bulkInquiry.modal.length")}
                          </span>
                          <TextValidator
                            size="small"
                            className={classes.textField}
                            fullWidth
                            name="length"
                            type="number"
                            value={form.length || ""}
                            onChange={handleChange}
                            error={!!inputErrors.length}
                          />
                        </Grid>
                        <Grid item xs={12} md={3.8}>
                          <span className={classes.inputTitle}>
                            {" "}
                            {t("bulkInquiry.modal.width")}
                          </span>
                          <TextValidator
                            size="small"
                            className={classes.textField}
                            fullWidth
                            name="width"
                            type="number"
                            value={form.width || ""}
                            onChange={handleChange}
                            error={!!inputErrors.width}
                          />
                        </Grid>
                        <Grid item xs={12} md={3.8}>
                          <span className={classes.inputTitle}>
                            {" "}
                            {t("bulkInquiry.modal.height")}
                          </span>
                          <TextValidator
                            size="small"
                            className={classes.textField}
                            fullWidth
                            name="height"
                            type="number"
                            value={form.height || ""}
                            onChange={handleChange}
                            error={!!inputErrors.height}
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        <span className={classes.inputTitle}>
                          {" "}
                          {t("bulkInquiry.modal.description")}
                        </span>
                        <TextValidator
                          size="small"
                          className={classes.textField}
                          fullWidth
                          name="description"
                          value={form.description || ""}
                          onChange={handleChange}
                          error={!!inputErrors.description}
                        />
                      </Grid>
                    </Grid>
                    <div className={classes.btnSection}>
                      <Button
                        variant="contained"
                        className={classes.submitBtn}
                        type="submit"
                      >
                        {t("bulkInquiry.modal.send")}
                      </Button>
                    </div>
                  </ValidatorForm>
                </Box>
              )}
            </Box>
          </Dialog>
        </Grid>
      </Grid>
    </Container>
  );
}

export default BuyInBulk;
